import axios from 'axios';
import jwtDecode from 'jwt-decode';
import irelandApi from '../irelandApi';
import store from "../store"

export function clear(tokenName = 'accessToken') {
  localStorage.removeItem(tokenName);
  delete irelandApi.defaults.headers.common['Authorization'];
  delete axios.defaults.headers.common['Authorization'];
}

export default function setAuthorizationToken(token, name = 'accessToken') {
  if (token) {
    localStorage.setItem(name, token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    clear();
  }
}

export function getAuthorizationToken(name = 'accessToken') {
  return localStorage.getItem(name);
}

export function check(token) {
  let theToken = token || getAuthorizationToken();
  return theToken && jwtDecode(theToken).exp < new Date().getTime();
}

export function isLoggedIn() {
  const token = getAuthorizationToken();
  return token && check(token);
}

export function isAdminLoggedIn() {
  // const usergroupId = App.getCurrentUser().attributes['user-group'];
  const token = getAuthorizationToken();
  return token && check(token) && store.getState().viewConfig.isAdmin;
}



// WEBPACK FOOTER //
// ./src/utils/tokenUtils.js